import React, { useState, useEffect } from 'react';
import '../styles/ProjectTracker.css';
import { getAllProjects, addProject, updateProject, deleteProject } from '../services/api';

function ProjectTracker() {
  const [filter, setFilter] = useState('all');
  const [projects, setProjects] = useState([]);
  const [newProject, setNewProject] = useState({ clientId: '', service: '', status: 'Pending', progress: 0 });
  const [editProject, setEditProject] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await getAllProjects();
        setProjects(data);
      } catch (err) {
        console.error('Failed to fetch projects:', err);
      }
    };
    fetchProjects();
  }, []);

  const handleAddProject = async (e) => {
    e.preventDefault();
    try {
      const response = await addProject(newProject);
      setProjects([...projects, response]);
      setNewProject({ clientId: '', service: '', status: 'Pending', progress: 0 });
    } catch (err) {
      alert('Failed to add project.');
    }
  };

  const handleUpdateProject = async (e) => {
    e.preventDefault();
    try {
      await updateProject(editProject.id, editProject);
      setProjects(projects.map(p => p.id === editProject.id ? editProject : p));
      setEditProject(null);
    } catch (err) {
      alert('Failed to update project.');
    }
  };

  const handleDeleteProject = async (projectId) => {
    if (window.confirm('Are you sure you want to delete this project?')) {
      try {
        await deleteProject(projectId);
        setProjects(projects.filter(p => p.id !== projectId));
      } catch (err) {
        alert('Failed to delete project.');
      }
    }
  };

  const filteredProjects = filter === 'all' ? projects : projects.filter(p => p.status.toLowerCase() === filter);

  return (
    <div className="ap-project-tracker">
      <h2 className="ap-tracker-title">All Projects</h2>
      <form className="ap-add-project-form" onSubmit={handleAddProject}>
        <input className="ap-tracker-input" name="clientId" placeholder="Client ID" value={newProject.clientId} onChange={(e) => setNewProject({ ...newProject, clientId: e.target.value })} required />
        <input className="ap-tracker-input" name="service" placeholder="Service" value={newProject.service} onChange={(e) => setNewProject({ ...newProject, service: e.target.value })} required />
        <select className="ap-tracker-select" name="status" value={newProject.status} onChange={(e) => setNewProject({ ...newProject, status: e.target.value })}>
          <option value="Pending">Pending</option>
          <option value="In Progress">In Progress</option>
          <option value="Completed">Completed</option>
        </select>
        <input className="ap-tracker-input" name="progress" type="number" placeholder="Progress (%)" value={newProject.progress} onChange={(e) => setNewProject({ ...newProject, progress: e.target.value })} min="0" max="100" required />
        <button className="ap-tracker-btn" type="submit">Add Project</button>
      </form>
      <div className="ap-tracker-filters">
        <button className="ap-filter-btn" onClick={() => setFilter('all')}>All</button>
        <button className="ap-filter-btn" onClick={() => setFilter('in progress')}>In Progress</button>
        <button className="ap-filter-btn" onClick={() => setFilter('completed')}>Completed</button>
        <button className="ap-filter-btn" onClick={() => setFilter('pending')}>Pending</button>
      </div>
      <table className="ap-tracker-table">
        <thead>
          <tr>
            <th>Client</th>
            <th>Service</th>
            <th>Status</th>
            <th>Progress</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredProjects.map((project) => (
            <tr key={project.id} className="ap-tracker-row">
              <td>{project.clientName}</td>
              <td>{project.service}</td>
              <td>{project.status}</td>
              <td>
                <div className="ap-progress-bar">
                  <div className="ap-progress-fill" style={{ width: `${project.progress}%` }}></div>
                </div>
              </td>
              <td>
                <button className="ap-edit-btn" onClick={() => setEditProject(project)}>Edit</button>
                <button className="ap-delete-btn" onClick={() => handleDeleteProject(project.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {editProject && (
        <form className="ap-edit-project-form" onSubmit={handleUpdateProject}>
          <h3 className="ap-edit-title">Edit Project</h3>
          <input className="ap-tracker-input" name="clientId" value={editProject.clientId} onChange={(e) => setEditProject({ ...editProject, clientId: e.target.value })} required />
          <input className="ap-tracker-input" name="service" value={editProject.service} onChange={(e) => setEditProject({ ...editProject, service: e.target.value })} required />
          <select className="ap-tracker-select" name="status" value={editProject.status} onChange={(e) => setEditProject({ ...editProject, status: e.target.value })}>
            <option value="Pending">Pending</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
          </select>
          <input className="ap-tracker-input" name="progress" type="number" value={editProject.progress} onChange={(e) => setEditProject({ ...editProject, progress: e.target.value })} min="0" max="100" required />
          <button className="ap-tracker-btn" type="submit">Save</button>
          <button className="ap-cancel-btn" type="button" onClick={() => setEditProject(null)}>Cancel</button>
        </form>
      )}
    </div>
  );
}

export default ProjectTracker;